<template>
  <footer class="footer has-cards">
    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
          <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
        </div>
        <div class="col-lg-6 text-lg-center btn-wrapper">
          <a target="_blank" rel="noopener" href="https://twitter.com/WAStickerApp"
             class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
             data-original-title="Follow us">
            <font-awesome-icon :icon="['fab','twitter']"/>
          </a>
          <a target="_blank" rel="noopener" href="https://www.facebook.com/WAStickerAppsStore/"
             class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
             data-original-title="Like us">
            <font-awesome-icon :icon="['fab','facebook-square']"/>
          </a>
          <a target="_blank" rel="noopener" href="mailto:appswasticker@gmail.com"
             class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
             data-original-title="Follow us">
            <font-awesome-icon :icon="['fa','envelope']"/>
          </a>
        </div>
      </div>
      <hr>
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-4">
          <div class="copyright">
            &copy; {{year}}
            <a href="https://github.com/diegulog" target="_blank" rel="noopener">Diego Gl</a>
          </div>
        </div>
        <div class="col-md-8">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <router-link  to="/terms" class="nav-link">
                <span class="nav-link">Terms &amp; Conditions</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link  to="/privacy_en" class="nav-link">
                <span class="nav-link">Privacy Policy</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link  to="/DMCA_Policy" class="nav-link">
                <span class="nav-link">DMCA Policy</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'starter-footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style>
</style>
